export default class BackStoreAddress {
    contactName: string;
    storeName: string;
    storeAddress: string;
    contactPhone: string;
    id: number;
    remark: string;
    site: number;
    whetherLocal: boolean;
    whetherEffective: boolean;
    onlyOneShelfCost?: number;
    deductIntegral?: number;
    deductionCycle?: number;
    beginDeductionTime?: Date;
}